module.exports = __webpack_public_path__ + "static/media/387.7469ad3b.png";